import BaseAPI from '../api'
const path = 'files'

export interface CreateFileInterface {
    folderName: string
    folderLocation?: string
    idFiscalyear?: number
    idDepartment?: number
    idReferFolder?: number
}


export default class FileApi extends BaseAPI {

    static postFileInFolder(idFolder: number, formData: any): Promise<any> {
        return this.api.post(`folders/${idFolder}/${path}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((res) => res)
    }
    static postFile(props: CreateFileInterface): Promise<any> {
        return this.api.post(`${path}`, { ...props }, {})
            .then((res) => res)
    }
    static patchFile(idFile: number, formData: any): Promise<any> {
        return this.api.patch(`${path}/${idFile}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((res) => res)
    }
    static getFile(idFile: number): Promise<any> {
        return this.api.get(`${path}/${idFile}/info`, {})
            .then((res) => res)
    }
    static getFileSearch(idFile: number): Promise<any> {
        return this.api.get(`${path}/${idFile}`, {})
            .then((res) => res)
    }
    static deleteFile(idFile: number): Promise<any> {
        return this.api.delete(`${path}/${idFile}`, {})
            .then((res) => res)
    }
    static getFileDownload(idFile: number): Promise<any> {
        return this.api.get(`${path}/${idFile}/download`, {
            responseType: 'arraybuffer'
        }).then((res) => res)
    }
    static getBulkFileDownload(ids: string): Promise<any> {
        return this.api.get(`${path}/bulk-download`, {
            params: {ids},
            responseType: 'arraybuffer'
        }).then((res) => res)
    }
    static getBulkFileDelete(ids: string): Promise<any> {
        return this.api.delete(`${path}/bulk-delete`, {
            params: {ids},
        }).then((res) => res)
    }
}
